import { render, staticRenderFns } from "./PeopleSearchForm.vue?vue&type=template&id=4af89b67&scoped=true&"
import script from "./PeopleSearchForm.vue?vue&type=script&lang=js&"
export * from "./PeopleSearchForm.vue?vue&type=script&lang=js&"
import style0 from "./PeopleSearchForm.vue?vue&type=style&index=0&id=4af89b67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af89b67",
  null
  
)

export default component.exports